module.exports = __webpack_public_path__ + "static/assets/5d645e44174fd3570bc828e4116f4a94.png";